import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import RouteGuard from '../../shared/RouteGuard';
import EventFoundationPanel from './EventFoundationPanel';
import ProgramsView from './ProgramsView';
import { readProgramWorkbook } from './workbookInvitees';

// /events/programs and /events/:engagementId/plan. Same door as /events: closed unless the Events pack is on.
export function ProgramsRoute({ enabled, loading, isUser }) {
    const navigate = useNavigate();
    if (loading) return <div className="p-8 text-center text-gray-400">Loading…</div>;
    if (!enabled) return <Navigate to="/dashboard" replace />;
    return (
        <RouteGuard module="events" action="view" isUser={isUser}>
            <ProgramsView read={readProgramWorkbook} onOpenEvent={(event) => navigate(`/events/${event.event_id}/plan`)} />
        </RouteGuard>
    );
}

export function EventPlanRoute({ enabled, loading, isUser }) {
    const { engagementId } = useParams();
    const navigate = useNavigate();
    if (loading) return <div className="p-8 text-center text-gray-400">Loading…</div>;
    if (!enabled) return <Navigate to="/dashboard" replace />;
    return (
        <RouteGuard module="events" action="view" isUser={isUser}>
            <EventFoundationPanel eventId={engagementId} onBack={() => navigate('/events')} />
        </RouteGuard>
    );
}
